import React, {useState, useEffect, useCallback} from 'react';
import {Box, createTheme, useMediaQuery, ThemeProvider} from '@mui/material';
import Cookies from 'js-cookie';
// import nookies from 'nookies';
import PageNav from '../../components/PageNav';
import {AddCircleIcon, macWP, IconProfile} from '../../assets';
import {Language} from '../../context/LanguageContext';
import {ModalFlexible, UserAccessCard} from '../../components';
import {Search} from '@material-ui/icons';
import {useUser} from '../../hooks';
import {USER_ACCESS_TAB_LIST} from '../../consts/common';
import {useSearchParams} from 'react-router-dom';
import '../../assets/styles/userListV2.scss';

export default function UserAccessListV2({
  type,
  displayAddBtn = true,
  setRole,
  user,
}) {
  const [payload, setPayload] = useState({
    tab: USER_ACCESS_TAB_LIST[type][0]?.value,
    q: '',
  });
  const [searchParams] = useSearchParams();
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const {language, newObj} = Language();
  const tokens_session = Cookies.get('token');
  const {getUserList, getUserGroupList, getPICList, searchPIC} = useUser();
  const [userAccessList, setUserAccessList] = useState([]);
  const tabList = USER_ACCESS_TAB_LIST[type];
  const [selected, setSelected] = useState(null);
  const theme = createTheme({
    typography: {
      fontFamily: ['Montserrat'],
    },
  });
  const isXsScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
  const isSmScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const handleAddButton = (type) => {
    switch (type) {
      case 'user':
        setModalType('addUser');
        break;
      case 'group':
        setModalType('addGroup');
        break;
      case 'pic':
        return;
      default:
        break;
    }
    setOpenModal(true);
  };
  const addButtonText = (type) => {
    switch (type) {
      case 'user':
        return newObj.AddNewUserWord[language];
      case 'group':
        return newObj.AddNewGroupWord[language];
      case 'pic':
        return newObj.AddNewPICWord[language];
      case 'documentation':
        return newObj.AddFileWord[language];
      default:
        return '';
    }
  };
  const userAccessCardProps = (type, item) => {
    switch (type) {
      case 'user':
        return {
          avatar: item.avatar || IconProfile,
          textUpper: `${item.firstname} ${item.lastname}`,
          textLower: item.username,
          onClick: () => {
            setModalType('editUser');
            setSelected({...item, setRole, user});
            setOpenModal(true);
          },
        };
      case 'group':
        return {
          textUpper: item.name,
          textLower: '',
          withImage: false,
          onClick: () => {
            setModalType('editGroup');
            setSelected(item);
            setOpenModal(true);
          },
        };
      case 'pic':
        return {
          textUpper: item.namaKawasan,
          textLower: item.kodKawasan,
          avatar: item.avatar || IconProfile,
          onClick: () => {
            setModalType('editPIC');
            setSelected(item);
            setOpenModal(true);
          },
        };
      default:
        return;
    }
  };
  const handleGetDataList = useCallback(
    async (tokens_session, payload) => {
      let response = null;
      switch (type) {
        case 'user':
          response = await getUserList(tokens_session, {
            status: payload.tab,
            q: payload.q,
          });
          break;
        case 'group':
          response = await getUserGroupList(tokens_session, payload);
          break;
        case 'pic':
          if (payload.q) {
            response = await searchPIC(tokens_session, {
              status: payload.tab,
              q: payload.q,
            });
          } else
            response = await getPICList(tokens_session, {
              status: payload.tab,
              q: payload.q,
            });
          break;
        default:
          break;
      }
      const {data} = response;
      setUserAccessList(data?.data || []);
    },
    [type, payload, tokens_session]
  );
  const handleShowListData = (type) => {
    switch (type) {
      case 'user':
      case 'group':
      case 'pic':
        return userAccessList?.length > 0 ? (
          userAccessList.map((item) => (
            <UserAccessCard
              key={item.id}
              {...userAccessCardProps(type, item)}
            />
          ))
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '80vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '26px',
              fontWeight: 'bold',
            }}
          >
            {newObj.NoDataWord[language]}
          </Box>
        );
      default:
        return;
    }
  };
  const pageNavProps = (type) => {
    switch (type) {
      case 'user':
        return {
          title: newObj.UserWord[language],
          href: '/adminpage',
        };
      case 'group':
        return {
          title: newObj.GroupWord[language],
          href: '/adminpage',
        };
      case 'pic':
        return {
          title: newObj.PICWord[language],
          href: '/adminpage',
        };
      case 'documentation':
        return {
          title: newObj.DocumentationWord[language],
          href: '/adminpage',
        };
      default:
        return;
    }
  };
  useEffect(() => {
    searchParams.get('open') === 'true' && handleAddButton(type);
  }, []);
  useEffect(() => {
    handleGetDataList(tokens_session, payload);
  }, [tokens_session, payload.tab]);

  return (
    <>
      <Box
        sx={{
          backgroundImage: `url(${macWP})`,
          backgroundRepeat: 'no-repeat',
          backgroundColor: (t) =>
            t.palette.mode === 'light'
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          paddingTop: isXsScreen || isSmScreen ? '10px' : '20px',
          display: 'flex',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <PageNav {...pageNavProps(type)} />
        <Box className='userlist_ctr'>
          <Box className='userlist_box'>
            <Box className='userlist_head'>
              <Box className='left'>
                <Box className='tab_ctr'>
                  {tabList.map((tab, index) => (
                    <button
                      key={tab.value + index}
                      className={`tab ${
                        payload.tab === tab.value ? 'active' : ''
                      }`}
                      onClick={() =>
                        setPayload((prev) => ({...prev, tab: tab.value}))
                      }
                    >
                      {tab.label}
                    </button>
                  ))}
                </Box>
              </Box>
              <Box className='right'>
                <form
                  className='search_input_ctr'
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleGetDataList(tokens_session, payload);
                  }}
                  action='POST'
                >
                  <input
                    type='text'
                    name='q'
                    onChange={(e) =>
                      setPayload((prev) => ({...prev, q: e.target.value}))
                    }
                    className='search_input'
                  />
                  <Search className='search_icon' />
                </form>
                {displayAddBtn && (
                  <button
                    className='add_new_btn'
                    onClick={() => handleAddButton(type)}
                  >
                    <img src={AddCircleIcon} alt='icon' />
                    {addButtonText(type)}
                  </button>
                )}
              </Box>
            </Box>
            <Box className='userlist_card_ctr'>{handleShowListData(type)}</Box>
          </Box>
        </Box>
      </Box>
      {openModal && (
        <ModalFlexible
          type={modalType}
          data={{selected}}
          onClose={() => {
            handleGetDataList(tokens_session, payload);
            setOpenModal(false);
            setSelected(null);
          }}
        />
      )}
    </>
  );
}
